import { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { IGetFormRejectReasonsResponse } from "../../models/registration.model";
import { getFormRejectReasons } from "../../services/registration.service";
import { IFormInnerState } from "../requestSteps/form/IFormInnerState";
import CaptureVideo from "./captureVideo";
import VideoError from "./videoError";
import VideoHints from "./videoHints";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
export default function KycVideo({ setFormInnerState, setStep, referenceKey }: IFormInnerState) {
    const navigate = useNavigate();
    const [rejectReasons, setRejectReasons] = useState<string[]>([]);

    const { mutate: GetRejectReasonsMutate } = useMutation(
        getFormRejectReasons,
        {
            onSuccess: (data: IGetFormRejectReasonsResponse[]) => {

                if (data) {
                    setRejectReasons(data[0]?.rejectReasons)
                }
            },
        }
    );

    useEffect(() => {
        GetRejectReasonsMutate({
            referenceKey: referenceKey!,
            form: "KycVideo"
        })
    }, [])


    const setState = (state: 'videoHint' | 'captureVideo') => navigate(`/loans/request/KycVideo/${state === 'videoHint' ? '' : state}`);
    return <Routes>
        <Route index element={rejectReasons?.length ? <VideoError setState={setState} referenceKey={referenceKey!} rejectReasons={rejectReasons} /> : <VideoHints setState={setState} referenceKey={referenceKey!} />} />
        <Route path="captureVideo" element={<CaptureVideo setStep={setStep} referenceKey={referenceKey!} />} />
        <Route path="*" element={<Navigate to="/loans/request/KycVideo" replace />} />
    </Routes>
}
